import APIClient from "@axioscode/api-client";

import Log from "utils/log";
import { OAUTH, BACKEND_ROOT } from "config/constants";
import createAsyncAction from "utils/createAsyncAction";

export const AUTH_SUCCEEDED = "AUTH_SUCCEEDED";
export const AUTH_FAILED = "AUTH_FAILED";
export const CLIENT_UPDATED = "CLIENT_UPDATED";
export const LOGOUT_SUCCEEDED = "LOGOUT_SUCCEEDED";
export const LOGOUT_FAILED = "LOGOUT_FAILED";
export const LOGOUT_REQUESTED = "LOGOUT_REQUESTED";
export const READ_CURRENT_USER_SUCCEEDED = "READ_CURRENT_USER_SUCCEEDED";
export const READ_CURRENT_USER_FAILED = "READ_CURRENT_USER_FAILED";
export const READ_CURRENT_USER_REQUESTED = "READ_CURRENT_USER_REQUESTED";

export const authSucceeded = (token, client) => {
  return {
    type: AUTH_SUCCEEDED,
    payload: { token, client },
  };
};

export const authFailed = err => {
  Log.error(err);
  return {
    type: AUTH_FAILED,
  };
};

export const updateClient = client => {
  return {
    type: CLIENT_UPDATED,
    payload: { client },
  };
};

export const readCurrentUserAsync = createAsyncAction(
  "users",
  "read",
  "READ_CURRENT_USER",
  () => "me"
);

export const finishOAuthFlow = url => {
  return (dispatch, getState) => {
    const { client } = getState();

    return client.token && "getToken" in client.token
      ? client.token
          .getToken(url, { state: client.options.state })
          .then(token => {
            client.token = token;
            // Get information about the current user from the /users/me endpoint
            dispatch(authSucceeded(token, client));
            return dispatch(readCurrentUserAsync());
          })
          .then(({ payload }) => {
            Log.setUserContext(payload);
          })
          .catch(error => {
            dispatch(authFailed(error));
          })
      : Promise.resolve();
  };
};

export const logoutRequested = () => ({
  type: LOGOUT_REQUESTED,
});

export const logoutSucceeded = () => ({
  type: LOGOUT_SUCCEEDED,
});

export const logoutFailed = err => ({
  type: LOGOUT_FAILED,
  payload: err,
  error: true,
});

export const logout = () => {
  return (dispatch, getState) => {
    const { token } = getState();
    dispatch(logoutRequested());

    return new APIClient({
      token,
      clientId: OAUTH.CLIENT_ID,
      scopes: OAUTH.SCOPES,
      backendRoot: BACKEND_ROOT,
    })
      .revoke()
      .then(() => {
        dispatch(logoutSucceeded());
        Log.setUserContext();
      })
      .catch(err => dispatch(logoutFailed(err)));
  };
};
